import React, { useMemo, useState } from 'react';
import type { CommentTreeNode } from "../../lib/utils/unflatten";
import classNames from 'classnames';
import type { CommentTreeOptions } from '../comments/commentTree';
import { useCurrentTime } from '../../lib/utils/timeUtil';
import CommentsList from "../comments/CommentsList";
import { defineStyles } from '@/components/hooks/defineStyles';
import { useStyles } from '@/components/hooks/useStyles';

const styles = defineStyles('AnswerCommentsList', (theme: ThemeType) => ({
  commentsList: {
    marginLeft: -4,
    marginRight: -12,
    marginBottom: 16,
    marginTop: 8,
  },
  noComments: {
    position: "relative",
    textAlign: "right",
    top: -64
  },
  noCommentAnswersList: {
    borderTop: 'transparent'
  },
  editor: {
    marginLeft: 32,
    marginTop: 16,
    paddingLeft: 12,
    paddingBottom: 12,
    borderTop: `solid 1px ${theme.palette.grey[300]}`
  },
  newComment: {
    padding: 20,
    textAlign: 'right',
    color: theme.palette.grey[600]
  },
  loadMore: {
    color: theme.palette.primary.main,
    textAlign: 'right'
  },
}))

const AnswerCommentsList = ({post, parentAnswer, commentTree, treeOptions}: {
  post: PostsList,
  commentTree: CommentTreeNode<CommentsList>[],
  treeOptions: CommentTreeOptions,
  parentAnswer: CommentsList,
}) => {
  const classes = useStyles(styles);
  const totalCount = parentAnswer.descendentCount;
  const now = useCurrentTime();
  const treeOptionsWithHighlight = useMemo(() => ({
    ...treeOptions,
    highlightDate: post?.lastVisitedAt ? new Date(post.lastVisitedAt) : now,
  }), [treeOptions, post?.lastVisitedAt, now]);
  
  return <div className={classes.commentsList}>
    <CommentsList
      treeOptions={treeOptionsWithHighlight}
      totalComments={totalCount}
      comments={commentTree}
      parentCommentId={parentAnswer._id}
      parentAnswerId={parentAnswer._id}
      defaultNestingLevel={1}
      startThreadTruncated
    />
  </div>
}

export default AnswerCommentsList;



